import Icon from '../components/Icon.vue'

Icon.register({"sticky-note":{"width":448,"height":512,"paths":[{"d":"M312 320H448V56C448 42.7 437.3 32 424 32H24C10.7 32 0 42.7 0 56V456C0 469.3 10.7 480 24 480H288V344C288 330.8 298.8 320 312 320zM441 375L343 473C338.5 477.5 332.4 480 326 480H320V352H448V358.1C448 364.4 445.5 370.5 441 375z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/sticky-note.js
// module id = null
// module chunks = 